import React from "react";
import { Empty } from "antd";

const NoData = ({ text, className }) => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={text || "No data"}
      className={className}
    />
  );
};

export default NoData;
